"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = Object.freeze((0, _keyMirror.default)({
  COMPATIBLE_ANY: null,
  COMPATIBLE_BLOG: null,
  COMPATIBLE_EMAIL: null,
  COMPATIBLE_PAGE: null
}));

exports.default = _default;
module.exports = exports.default;